import { Spinner } from '@/components/ui/Spinner'

import { PageLoaderContainer } from './styles'

/**
 * 진입/페이지 로딩 표시 — 백색 전체 화면 중앙 스피너.
 *
 * 결제 진행 중 검정 딤 오버레이(LoadingOverlay)와 달리, 앱 진입·데이터 로딩처럼
 * "아직 화면이 없는" 단계에서 백색 배경에 스피너만 돌린다.
 */
export function PageLoader() {
  return (
    <PageLoaderContainer
      role='status'
      aria-label='불러오는 중'
    >
      <Spinner />
    </PageLoaderContainer>
  )
}
